module.exports = __webpack_public_path__ + "img/coupon_popup_btn2.3a2353d4.png";